var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 10C11.6654 10.4603 12.0385 10.8334 12.4987 10.8334C12.9589 10.8334 13.332 10.4603 13.332 10C13.332 9.53978 12.9589 9.16669 12.4987 9.16669C12.0385 9.16669 11.6654 9.53978 11.6654 10Z",
    fill: "Current",
    stroke: "Current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 15.8333C11.6654 16.2936 12.0385 16.6667 12.4987 16.6667C12.9589 16.6667 13.332 16.2936 13.332 15.8333C13.332 15.3731 12.9589 15 12.4987 15C12.0385 15 11.6654 15.3731 11.6654 15.8333Z",
    fill: "Current",
    stroke: "Current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 4.16668C11.6654 4.62691 12.0385 5.00001 12.4987 5.00001C12.9589 5.00001 13.332 4.62691 13.332 4.16668C13.332 3.70644 12.9589 3.33334 12.4987 3.33334C12.0385 3.33334 11.6654 3.70644 11.6654 4.16668Z",
    fill: "Current",
    stroke: "Current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 10C6.66536 10.4603 7.03846 10.8334 7.4987 10.8334C7.95894 10.8334 8.33203 10.4603 8.33203 10C8.33203 9.53978 7.95894 9.16669 7.4987 9.16669C7.03846 9.16669 6.66536 9.53978 6.66536 10Z",
    fill: "#808191",
    stroke: "Current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 15.8333C6.66536 16.2936 7.03846 16.6667 7.4987 16.6667C7.95894 16.6667 8.33203 16.2936 8.33203 15.8333C8.33203 15.3731 7.95894 15 7.4987 15C7.03846 15 6.66536 15.3731 6.66536 15.8333Z",
    fill: "#808191",
    stroke: "Current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 4.16668C6.66536 4.62691 7.03846 5.00001 7.4987 5.00001C7.95894 5.00001 8.33203 4.62691 8.33203 4.16668C8.33203 3.70644 7.95894 3.33334 7.4987 3.33334C7.03846 3.33334 6.66536 3.70644 6.66536 4.16668Z",
    fill: "Current",
    stroke: "Current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.7d42132790a708c591191cf866b69b44.svg";
export { ForwardRef as ReactComponent };